module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "user-detail"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": '/organizations'
    }
  }, [_vm._v("Organisasi")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Organisasi Detail")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Informasi Detail Organisasi")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('a', {
    staticClass: "media-left",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('img', {
    staticClass: "media-object",
    attrs: {
      "src": _vm.organization.picture,
      "alt": "profile_picture"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_vm._m(1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.organization.name))])]), _vm._v(" "), _c('tr', [_vm._m(2), _vm._v(" "), _c('td', _vm._l((_vm.organization.admin_data), function(item, index) {
    return _c('span', {
      key: index
    }, [_vm._v("\n                        " + _vm._s(item.name) + ",\n                      ")])
  }), 0)]), _vm._v(" "), _c('tr', [_vm._m(3), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.organization.province))])]), _vm._v(" "), _c('tr', [_vm._m(4), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.organization.city))])]), _vm._v(" "), _c('tr', [_vm._m(5), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.organization.npsn))])]), _vm._v(" "), _c('tr', [_vm._m(6), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.organization.address))])]), _vm._v(" "), _c('tr', [_vm._m(7), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.organization.contact))])]), _vm._v(" "), _c('tr', [_vm._m(8), _vm._v(" "), _c('td', _vm._l((_vm.organization.admin_data), function(item, index) {
    return _c('span', {
      key: index
    }, [_vm._v("\n                        " + _vm._s(item.email) + ",\n                      ")])
  }), 0)]), _vm._v(" "), _c('tr', [_vm._m(9), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.organization.child_count))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('router-link', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "to": {
        name: 'OrganizationForm',
        params: {
          id: _vm.organization.id
        }
      }
    }
  }, [_vm._v("\n                        Edit\n                      ")])], 1)])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_vm._m(11), _vm._v(" "), _c('tbody', _vm._l((_vm.listCabang), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('th', [_vm._v("\n                  " + _vm._s(index + 1) + "\n                ")]), _vm._v(" "), _c('th', [_vm._v("\n                  " + _vm._s(item.name) + "\n                ")]), _vm._v(" "), _c('th', [_vm._v("\n                  " + _vm._s(item.student_count) + "\n                ")])])
  }), 0)])])])])]), _vm._v(" "), (_vm.isBulkModal) ? _c('organizations-bulk', {
    attrs: {
      "isMapping": _vm.isMapping
    },
    on: {
      "submitMapping": _vm.submitMapping,
      "reload": _vm.loadStudentData,
      "close": function($event) {
        _vm.isBulkModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Organisasi Info")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "15%"
    }
  }, [_c('strong', [_vm._v("Nama Organisasi")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Nama Admin")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Provinsi")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Kota/Kabupaten")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("NPSN")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Alamat")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("No. Telpon")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Email Admin ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Jumlah Cabang")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("\n            Daftar Cabang\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("No.")]), _vm._v(" "), _c('th', [_vm._v("Nama Cabang")]), _vm._v(" "), _c('th', [_vm._v("Jumlah Siswa")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fe26a6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/organizations/OrganizationDetail.vue
// module id = 1299
// module chunks = 0